import { defineMessages } from "react-intl";

const messages = defineMessages({
  copied: {
    defaultMessage: "Link copied!",
  },
  shareText: {
    defaultMessage: "Share",
  },
});

export default messages;
